import React, { useEffect, useState } from 'react';
import './styles/infinite-slider-panel.css';
import './styles/infinite-slider.css';

export default function EndOfPhotos() {

    return (
        <div className='end-of-photos-text'>
            You have seen every photo.
            <br></br><br></br>I hope you enjoyed a small window into my life.
        </div>
    );
}

